<div class="reset-page">
  <div class="reset-card">
    <div class="reset-header">
      <img class="reset-logo" [src]="logo" alt="SAMgruppen">
      <h1 class="reset-title sam-page-heading">
        {{ passwordReset.Code == undefined ? 'Gl&ouml;mt l&ouml;senord' : 'Ange nytt l&ouml;senord' }}
      </h1>
      <p class="reset-subtitle" *ngIf="passwordReset.Code == undefined">
        Fyll i din e-postadress s&aring; skickar vi en l&auml;nk f&ouml;r att skapa ett nytt l&ouml;senord.
      </p>
      <p class="reset-subtitle" *ngIf="passwordReset.Code != undefined">
        Ange e-postadress och ditt nya l&ouml;senord f&ouml;r att slutf&ouml;ra &aring;terst&auml;llningen.
      </p>
    </div>

    <div class="reset-meta">
      <span>Kom du fel?</span>
      <a class="reset-link" [routerLink]="['/login']">Tillbaka till inloggning</a>
    </div>

    <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate class="reset-form">
      <ng-container *ngIf="passwordReset.Code == undefined">
        <mat-form-field color="accent" floatLabel="auto">
          <mat-icon after color="accent" matSuffix>mail</mat-icon>
          <input
            matInput
            type="email"
            [ngModel]="user.Email"
            required
            (ngModelChange)="user.Email = $event"
            placeholder="E-postadress"
            id="userEmail"
            name="userEmail">
        </mat-form-field>

        <div class="reset-actions">
          <span class="helper-text">Vi skickar instruktioner till den adress du anger om den finns registrerad hos oss.</span>
          <button [disabled]="loading" mat-raised-button color="accent" type="submit" name="action" class="primary-button">
            Skicka l&auml;nk
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="passwordReset.Code != undefined">
        <mat-form-field color="accent" floatLabel="auto">
          <mat-icon after color="accent" matSuffix>mail</mat-icon>
          <input
            matInput
            [ngModel]="passwordReset?.Email"
            required
            (ngModelChange)="passwordReset.Email = $event"
            type="email"
            placeholder="E-postadress"
            id="passwordResetuserEmail"
            name="passwordResetuserEmail">
        </mat-form-field>

        <mat-form-field color="accent" floatLabel="auto">
          <mat-icon after color="accent" matSuffix>vpn_key</mat-icon>
          <input
            matInput
            [ngModel]="passwordReset?.Password"
            required
            (ngModelChange)="passwordReset.Password = $event"
            placeholder="L&ouml;senord"
            type="password"
            id="passwor"
            name="password">
        </mat-form-field>

        <mat-form-field color="accent" floatLabel="auto">
          <mat-icon after color="accent" matSuffix>vpn_key</mat-icon>
          <input
            matInput
            [ngModel]="passwordReset?.ConfirmPassword"
            required
            (ngModelChange)="passwordReset.ConfirmPassword = $event"
            placeholder="Upprepa l&ouml;senord"
            type="password"
            id="passwordrepeat"
            name="passwordrepeat">
        </mat-form-field>

        <div class="errorMessage" *ngIf="!validatePasswordReset()">
          L&ouml;senorden matchar inte varandra.
        </div>

        <div class="reset-actions">
          <span class="helper-text">V&auml;lj ett nytt l&ouml;senord och bekr&auml;fta det nedan.</span>
          <button
            [disabled]="loading || !validatePasswordReset()"
            mat-raised-button
            color="accent"
            type="submit"
            name="action"
            class="primary-button">
            &Aring;terst&auml;ll l&ouml;senord
          </button>
        </div>
      </ng-container>
    </form>
  </div>
</div>
